import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_close",
  "use": "micro_close-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_close\"><path fill-rule=\"evenodd\" d=\"M5 5.707 2.211 8.496a.995.995 0 0 1-1.416.006l.703.703a1.006 1.006 0 0 1 .006-1.416L4.293 5 1.504 2.211A.995.995 0 0 1 1.498.795l-.703.703a1.006 1.006 0 0 1 1.416.006L5 4.293l2.789-2.789A.997.997 0 0 1 9.207 1.5L8.5.793a1.006 1.006 0 0 1-.004 1.418L5.707 5l2.789 2.789c.4.4.395 1.028.004 1.418l.707-.707a1.006 1.006 0 0 1-1.418-.004L5 5.707Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol